import React from 'react';

import { Stack, xcss } from '@atlaskit/primitives';

import { SpaceRoleType } from '@confluence/space-roles/entry-points/graphql';

import { useRoleList } from '../roles-list/useRoleList';

import { CustomRolesSection } from './role-sections/CustomRolesSection';
import { DefaultRolesSection } from './role-sections/DefaultRolesSection';

const roleManagementViewStyle = xcss({
	padding: 'space.100',
	gap: 'space.400',
});

const defaultRoleSectionStyle = xcss({
	gap: 'space.300',
});

const customRoleSectionStyle = xcss({
	gap: 'space.200',
});

export const RolesManagementView = () => {
	const { roles } = useRoleList();

	return (
		<Stack xcss={roleManagementViewStyle}>
			<Stack xcss={defaultRoleSectionStyle}>
				<DefaultRolesSection
					defaultRoleNodes={roles.filter((role) => role.roleType === SpaceRoleType.SYSTEM)}
				/>
			</Stack>
			<Stack xcss={customRoleSectionStyle}>
				<CustomRolesSection
					customRoleNodes={roles.filter((role) => role.roleType === SpaceRoleType.CUSTOM)}
				/>
			</Stack>
		</Stack>
	);
};
